import { useQuery } from "@tanstack/react-query";
import type { PortfolioPanelResponses, PortfolioQueryParams } from "@finance-os/shared-types/api";
import type { PortfolioPanelConst } from "@finance-os/shared-types/constants";
import { api } from "../api.js";
import { portfolioQueryKey } from "./portfolio-query.js";

/**
 * One portfolio dashboard panel's data. `params` carry the pinned `as_of`, so a
 * panel's query key only changes when the period or account does.
 */
export function usePortfolio<P extends PortfolioPanelConst>(panel: P, params: PortfolioQueryParams) {
  return useQuery<PortfolioPanelResponses[P]>({
    queryKey: portfolioQueryKey(panel, params),
    queryFn: () => api.portfolio(panel, params),
  });
}
